// Branding

// TODO: BRANDING AND INTL-MESSAGES HAVE CIRCULAR DEPENDENCIES. REFACTOR TO FIX

import * as _ from 'lodash';

import Messages from '../config/intl-messages';

export default abstract class Branding {
    public static appBrandKeys = {
        //  App branding keys
        complexSolutions: 'complex-solutions',
        appliedReserve: 'applied-reserve-analysis',
    };

    public static appBrandLogoLocations = {
        bidLetterFooter: 'bid-letter-footer',
        bidLetterHeader: 'bid-letter-header',
        branding: '/Branding/',
        login: 'login',
        nav: 'nav',
        reportCoverPage: 'report-cover-page',
        reportFooter: 'report-footer',
        reportPortal: 'report-portal',
        signatures: '/signatures/',
    };

    public static appBrandImageFileNames = {
        signatureNotFound: 'signature-not-found.png'
    };

    public static getInitialBrandingState(brandKey?: string) {
        // console.log(`branding.tsx getInitialBrandingState brandKey ${brandKey}`);
        return {
            brandKey: brandKey,
            companyName: Branding.getBrandCompanyName(brandKey),
            copyrightYears: '2024',
            defaultAvatar: Branding.getDefaultAvatar(brandKey),
            logo: {
                login: Branding.getBrandLogo(brandKey, Branding.appBrandLogoLocations.login),
                nav: Branding.getBrandLogo(brandKey, Branding.appBrandLogoLocations.nav),
                reportCoverPage: Branding.getBrandLogo(brandKey, Branding.appBrandLogoLocations.reportCoverPage),
                reportFooter: Branding.getBrandLogo(brandKey, Branding.appBrandLogoLocations.reportFooter),
                reportPortal: Branding.getBrandLogo(brandKey, Branding.appBrandLogoLocations.reportPortal),
                bidLeterHeader: Branding.getBrandLogo(brandKey, Branding.appBrandLogoLocations.bidLetterHeader),
                bidLetterFooter: Branding.getBrandLogo(brandKey, Branding.appBrandLogoLocations.bidLetterFooter),
            },
        };
    }

    public static getBrandingKey() {
        // Return site brand key, based on browser's window.location.host value. Used to toggle app text, logo, css, etc
        let key = Branding.appBrandKeys.complexSolutions;
        const host = window.location.hostname.toLowerCase();

        switch (host) {
            default:
            case 'localhost':
            case 'complex-solutions':
            case 'complex-reserve.ns8.com':
            case 'app.complexsolutionsltd.com':
            case 'webapp.complexsolutionsltd.com':
            case 'portal.complexsolutionsltd.com':
                key = Branding.appBrandKeys.complexSolutions;
                break;
            case 'applied-reserve-analysis':
            case 'applied-reserve-analysis.ns8.com':
            case 'app.appliedreserveanalysis.com':
            case 'portal.appliedreserveanalysis.com':
                key = Branding.appBrandKeys.appliedReserve;
                break;
        }

        return key;
    }

    public static getBrandCompanyName(brandKey?: string): string {
        // Returns company name for brand
        const key = brandKey ? brandKey : Branding.getBrandingKey();

        return _.get(Messages.getBrandMessages(key), 'app.branding.company', '');
    }

    public static getBrandLogo(brandKey?: string, location: string = Branding.appBrandLogoLocations.login): string {
        // Returns logo for brand, for use on login or in app nav header. location is either 'login' or 'nav'
        const key = brandKey ? brandKey : Branding.getBrandingKey();

        const m = Messages.getBrandMessages(key);
        const result = _.get(m, `app.branding.images.logo.${location}`, '');

        // TODO: REFACTOR TO USE APPIMAGES

        return result;
    }

    public static getDefaultAvatar(brandKey?: string): string {
        // Returns default user avatar
        const key = brandKey ? brandKey : Branding.getBrandingKey();

        return _.get(Messages.getBrandMessages(key), `app.branding.images.defaultAvatar`, '');
    }

    public static getBrandUserSignaturePicture(fileName: string = Branding.appBrandImageFileNames.signatureNotFound, brandKey?: string, location: string = Branding.appBrandLogoLocations.branding): string {
        const key = brandKey ? brandKey : Branding.getBrandingKey();

        const result = `${location}${key}${Branding.appBrandLogoLocations.signatures}${fileName}`;

        return result;
    }
}



// WEBPACK FOOTER //
// ./src/branding/branding.tsx